import Filteration from "../components/Forms/Filteration";
import GenerateForm from "../components/Forms/GenerateForm";
import SmallSummaryCard from "../components/Reusables/Cards/SmallSummaryCard";
import { calTransSummary } from "../utils/calculateSummary";
import { CloseInner } from "../components/Forms/style";
import {
  FlexAutoContainer,
  InnerPageSideBar,
  LeftContent,
  RightContent,
  RouteContainer,
  SeeMore,
} from "../components/Generals/RouteStyles";
import { useAppDispatch, useAppSelector } from "../Redux/app/hooks";
import { toggleInnerSidebar } from "../Redux/Reducers/navReducer";
import AllTransactionsTable from "../components/Tables/AllTransactionsTable";
import { DotLoader } from "react-spinners";
import moment from "moment";
import { Date, DateRange } from "../components/Reusables/Cards/styles";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { LoggedInCheck2FAEnabled } from "../Apis/accountProcesing";
const Transaction = () => {
  const { openInnerSidebar } = useAppSelector((state) => state.nav);
  const dispatch = useAppDispatch();
  const { walletsTransactions, gettingWalletsTransactions } = useAppSelector(
    (state) => state.wallet
  );
  const navigate = useNavigate();
  const merchantDetails = JSON.parse(
    localStorage.getItem("merchantDetails") || "{}"
  );

  useEffect(() => {
    LoggedInCheck2FAEnabled(merchantDetails?.businessEmail, navigate);
  }, []);
  const transactionSummary = calTransSummary(walletsTransactions);

  return (
    <RouteContainer>
      <SeeMore onClick={() => dispatch(toggleInnerSidebar(true))}>
        <img src="/assets/icons/right-icon.svg" alt="right" />
        <span>view summary</span>
      </SeeMore>
      <FlexAutoContainer>
        <LeftContent flex="0.8" padding="0 0" style={{ overflowX: "auto" }}>
          <AllTransactionsTable />
        </LeftContent>
        <RightContent flex="0.2" padding="0 5px">
          <InnerPageSideBar toggle={openInnerSidebar}>
            <CloseInner onClick={() => dispatch(toggleInnerSidebar(false))}>
              x
            </CloseInner>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              {!gettingWalletsTransactions ? (
                <>
                  <DateRange className="text-red">
                    Date Range
                    <Date>
                      {moment(
                        walletsTransactions?.records[
                          walletsTransactions?.records?.length - 1
                        ]?.createdAt
                      ).format("MMM Do YYYY")}{" "}
                      -{" "}
                      {moment(
                        walletsTransactions?.records[0]?.createdAt
                      ).format("MMM Do YYYY")}
                    </Date>
                  </DateRange>
                  {transactionSummary?.map((item: any, index: any) => (
                    <SmallSummaryCard
                      title={item?.currency}
                      vol={item?.amount}
                      count={item?.count}
                      key={item + index}
                      network={item?.network}
                    />
                  ))}
                </>
              ) : (
                <div className="flex-center">
                  <DotLoader color="#ff6600" size={10} />
                </div>
              )}
            </div>
          </InnerPageSideBar>
        </RightContent>
      </FlexAutoContainer>
      <GenerateForm />
      <Filteration />
    </RouteContainer>
  );
};
export default Transaction;
